<template>
  <div>
    <v-card flat>
      <v-data-table
        v-model="selected"
        :loading="loading"
        :headers="headers"
        loading-text="Loading users"
        :items="users"
        item-key="id"
        :show-select="showSelect"
        :search="search"
        sort-by="email"
      >
        <template v-slot:top>
          <v-toolbar v-if="headerTitle" flat>
            <v-toolbar-title v-if="headerTitle">{{ headerTitle }}</v-toolbar-title>
          </v-toolbar>
          <v-toolbar v-if="withNavigation" flat>
            <v-text-field
              v-if="hasSearch"
              :disabled="disabled"
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            />
          </v-toolbar>
          <v-toolbar v-if="showSelect" flat>
            <v-text-field
              v-if="hasSearch"
              :disabled="disabled"
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            />
            <v-spacer/>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn :disabled="selected.length === 0 || loading || disabled" v-show="$vuetify.breakpoint.mdAndUp" v-on="on" text icon color="delete" @click="selectedUsersAction(selected)"><v-icon>mdi-delete-forever</v-icon></v-btn>
              </template>
              <span>Delete selected users</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn :disabled="loading || disabled" v-on="on" text icon color="add" @click="addUserAction"><v-icon>mdi-plus-circle</v-icon></v-btn>
              </template>
              <span>Invite users</span>
            </v-tooltip>
          </v-toolbar>
          <v-alert v-if="errorMessage" text dense type="error">
            {{ errorMessage }}
          </v-alert>
        </template>

        <template v-if="showSelect" v-slot:header.data-table-select="{ on, props }">
          <v-simple-checkbox :disabled="disabled" :ripple="false" v-bind="props" v-on="on"/>
        </template>

        <template v-if="showSelect" v-slot:item.data-table-select="{ isSelected, select }">
          <v-simple-checkbox :disabled="disabled" :ripple="false" :value="isSelected" @input="select($event)"/>
        </template>

        <template v-if="showSelect" v-slot:item.loadingBar="{ item }">
          <v-progress-circular v-if="item.loading" indeterminate color="loading"/>
        </template>

        <template v-if="withPriority" v-slot:item.prioritized="{ item }">
          <v-checkbox color="secondary" :disabled="disabled || item.prioritized" @change="onChangePrioritized(item)" :ripple="false" v-model="item.prioritized"/>
        </template>

          <template v-if="withNavigation" v-slot:item="{ item }">
            <router-link tag="tr" :to="{name: 'user', params: {userId: item.id}}">
              <td>{{ item.email }}</td>
            </router-link>
          </template>
      </v-data-table>
    </v-card>
    <v-footer v-show="$vuetify.breakpoint.smAndDown && selected.length > 0" class="sticky-footer">
      <v-btn
        :disabled="selected.length === 0 || disabled || loading"
        class="error"
        @click="selectedUsersAction(selected)">
        Delete Selected
      </v-btn>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: 'UserList',
  props: {
    users: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    showSelect: {
      type: Boolean,
      default: false
    },
    headerTitle: {
      type: String,
      required: ''
    },
    withNavigation: {
      type: Boolean,
      default: false
    },
    withPriority: {
      type: Boolean,
      default: false
    },
    selectedUsersAction: {
      type: Function,
      default: function (selectedUsers) {
        return ''
      }
    },
    addUserAction: {
      type: Function,
      default: function (selectedUsers) {
        return ''
      }
    },
    hasSearch: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    search: '',
    selected: [],
    headers: [
      {
        text: 'Email',
        align: 'left',
        value: 'email'
      }
    ]
  }),

  methods: {
    resetData: function () {
      this.search = ''
      for (let user of this.users) {
        user.loading = false
      }
      this.selected = []
    },
    onChangePrioritized: function (user) {
      user.loading = true
      this.$emit('change-priority', user)
    },

    setSelectedUsersLoading: function () {
      for (let user of this.selected) {
        user.loading = true
      }
    }
  },
  created () {
    if (this.withPriority) {
      this.headers.push(
        {
          text: 'Prioritized',
          value: 'prioritized'
        }
      )
    }
    if (this.showSelect) {
      this.headers.push(
        {
          text: '',
          value: 'loadingBar',
          sortable: false
        })
    }
  }
}
</script>

<style scoped>
  tr{
    cursor: pointer;
  }
  .v-input--hide-details{
    padding-top: 0;
    margin-top: 0;
  }
</style>
